module.exports = __webpack_public_path__ + "static/media/SoundCloud.10571f58.png";